<template>
  <div class="p-item-list-panel">
    <a
      v-touch:tap
      :href="'/product-details/?id=' + id"
      class="p-item-list-panel__link"
      @click.prevent.stop="viewProductDetails(id)"
    >
      <div class="p-item-list-panel__img">
        <img
          :src="imgPath"
          alt="商品画像"
          class="p-item-list-panel__img"
          :style="setOpacity"
        />
      </div>
      <div class="p-item-list-panel__content">
        <div class="p-item-list-panel__name" :class="{ is_ie: isIe }">
          <p class="p-item-list-panel__name__text">{{ name }}</p>
        </div>
        <p class="p-item-list-panel__point">
          <TitleMedium>{{ addComma(point) }}</TitleMedium>
          <span class="p-item-list-panel__point__unit">{{ unit }}</span>
        </p>
        <p v-if="discountRate" class="p-item-list-panel__discount_rate">
          ({{ discountRate }}%OFF)
        </p>
        <TextLabel
          v-if="status"
          :color="{ border: color, content: '#fff' }"
          :reverse="true"
          class="p-item-list-panel__status"
          >{{ status }}</TextLabel
        >
      </div>
    </a>
  </div>
</template>

<script lang="ts">
import TitleMedium from "@/common/components/atoms/TitleMedium.vue";
import TextLabel from "@/common/components/atoms/TextLabel.vue";
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconFavoriteCircle from "@/common/components/icons/IconFavoriteCircle.vue";
import IconFavorite56px from "@/common/components/icons/IconFavorite56px.vue";
import { Options, Vue } from "vue-class-component";
import commons from "@/common/store/modules/commons";
import globals from "@/general/store/modules/globals";

@Options({
  props: {
    id: { type: [String, Number], required: true },
    imgPath: { type: String, required: true },
    name: { type: String, required: true },
    color: { type: String, required: true },
    point: { type: Number, required: true },
    discountRate: { type: Number, required: false },
    isFavorite: { type: Boolean, required: true },
    status: { type: String, required: false },
    addToBrowserHistory: { type: Boolean, default: false },
    stock: { type: Number, required: false, default: 0 },
    stockControl: { type: Boolean, required: false, default: false }
  },
  components: {
    TitleMedium,
    TextLabel,
    IconBase,
    IconFavoriteCircle,
    IconFavorite56px
  }
})
export default class ItemListPanel extends Vue {
  id!: string | number;
  imgPath!: string;
  name!: string;
  color!: string;
  point!: number;
  discountRate!: number;
  isFavorite!: boolean;
  status!: string;
  addToBrowserHistory!: boolean;
  stock!: number;
  stockControl!: boolean;

  internalFavoriteState: any = "";

  get unit() {
    return commons.OrgPageSpecific?.point_name;
  }

  get browser() {
    return globals.browser;
  }

  get isIe() {
    //return globals.browser === "ie";
    return false;
  }

  get setOpacity() {
    if (!this.stockControl) {
      return { opacity: 1 };
    }
    if (!this.stock) {
      return { opacity: 0.3 };
    }
    return false;
  }

  async created() {
    await commons.setOrgPageSpecificDataFromLocalStorage();
    this.initFavoriteState();
  }

  toggleFavorite() {
    this.internalFavoriteState = !this.internalFavoriteState;
  }
  initFavoriteState() {
    this.internalFavoriteState = this.isFavorite;
  }

  viewProductDetails(id: number) {
    window.location.href = "/product-details/?id=" + id;
  }
  
  addComma(value: any) {
    const number = Number(value);
      if (Number.isNaN(number)) {
        return value;
      }
      return number.toLocaleString();
    }
}
</script>

<style lang="scss" scoped>
.p-item-list-panel {
  position: relative;
  background-color: $common-white;
  user-select: none;

  &__link {
    display: block;
    height: 100%;

    &.tap {
      opacity: 0.5;
    }
  }

  &__link:hover {
    opacity: 0.5;
  }

  &__img {
    position: relative;
    padding: rem(14) rem(14) 0;

    @include large-sp {
      padding: 0;
    }

    &:before {
      content: "";
      display: block;
      padding-top: 100%;
    }

    img {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      margin: auto;
      @include object-fit("cover");
    }
  }

  &__content {
    padding: rem(8) rem(14) rem(14);

    @include large-sp {
      padding: rem(4) rem(8) rem(8);
    }
  }

  &__name {
    @include text__body--s;
    height: rem(40);

    &__text {
      overflow: hidden;
      text-overflow: ellipsis;
      @supports (-webkit-line-clamp: 2) {
        -webkit-box-orient: vertical;
        display: -webkit-box;
        -webkit-line-clamp: 2;
      }
    }

    // IEの場合、ホワイトアウトで対応
    &.is_ie &__text {
      position: relative;
      height: 100%;

      &::after {
        position: absolute;
        bottom: 0;
        right: 0;
        width: rem(48);
        height: rem(24);
        content: "";
        background: linear-gradient(
          to right,
          rgba(255, 255, 255, 0) 0%,
          rgba(255, 255, 255, 1) 50%,
          rgba(255, 255, 255, 1) 100%
        );
      }
    }
  }

  &__point {
    margin-top: rem(4);
    display: flex;
    align-items: flex-end;
  }

  &__point__unit {
    @include text__body--xs;
  }

  &__discount_rate {
    @include text__body--xs;
    color: $common-black-sub;
  }

  &__favorite {
    position: absolute;
    top: rem(14);
    right: rem(14);
    @include large-sp {
      top: 0;
      right: 0;
    }
  }

  &__status {
    position: absolute;
    top: rem(24);
    left: rem(22);
    @include large-sp {
      top: rem(10);
      left: rem(4);
    }
  }
}
</style>
